'use strict'

const date = {
	defaultFormat: 'YYYY-MM-DD',
}

export default date
